import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { CorrespondenciaRequest, CorrespondenciaResponse, CorRlCorrProtRequest, CorRlCorrDestinoRequest, CorRlTipoAssinaRequest, TipoCorrespondenciaResponse } from './correspondencia.model';

@Injectable({ providedIn: 'root' })
export class CorrespondenciaService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.correspondencia;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    gerarCorrespondencia(request: CorrespondenciaRequest, userId: string): Observable<CorrespondenciaResponse> {
        return this.http.post<CorrespondenciaResponse>(this.PATH, request, { params: { userId } });
    }

    salvarRelacaoProtocolo(request: CorRlCorrProtRequest): Observable<void> {
        return this.http.post<void>(`${this.PATH}/protocolo`, request);
    }

    salvarRelacaoDestino(request: CorRlCorrDestinoRequest): Observable<void> {
        return this.http.post<void>(`${this.PATH}/destino`, request);
    }

    cadastrarAssinante(request: CorRlTipoAssinaRequest): Observable<void> {
        return this.http.post<void>(`${this.PATH}/assinante`, request);
    }

    listarTodosTipos(): Observable<TipoCorrespondenciaResponse[]> {
        return this.http.get<TipoCorrespondenciaResponse[]>(`${this.PATH}/tipos`);
    }

    listarTiposPermitidos(idAssinante: number, uf: string): Observable<TipoCorrespondenciaResponse[]> {
        const params = { idAssinante: idAssinante.toString(), uf };
        return this.http.get<TipoCorrespondenciaResponse[]>(`${this.PATH}/permitidos`, { params });
    }

    verificarPermissao(userId: string, idTipoCorrespondencia: number): Observable<boolean> {
        const params = { userId, idTipoCorrespondencia: idTipoCorrespondencia.toString() };
        return this.http.get<boolean>(`${this.PATH}/permissao`, { params });
    }

    verificarExistencia(nuCorrespondencia: number, nuAnoCorrespondencia: number, idTipoCorrepondencia: number, uf: string): Observable<boolean> {
        const params = {
            nuCorrespondencia: nuCorrespondencia.toString(),
            nuAnoCorrespondencia: nuAnoCorrespondencia.toString(),
            idTipoCorrepondencia: idTipoCorrepondencia.toString(),
            uf
        };
        return this.http.get<boolean>(`${this.PATH}/existe`, { params });
    }
}
